import React from 'react'
import classnames from 'classnames'
import { Amount } from 'components/Amount'
import style from './style.module.scss'

const FinanceRow = ({
  status,
  title,
  date,
  amount,
  description,
  rejected,
  waiting,
  lastCol,
  swapSubRows,
}) => {
  const addition = amount > 0

  const amountClassName = classnames(style.amount, {
    [style.rejected]: rejected,
    [style.waiting]: waiting,
    [style.addition]: addition,
  })

  return (
    <tr className={style.financeRow}>
      {status && <td className={style.status}>{status}</td>}
      <td className={style.leftCol}>
        <div className={style.title}>{title}</div>
        {swapSubRows ? (
          <div className={style.description}>{description}</div>
        ) : (
          <div className={style.date}>{date}</div>
        )}
      </td>
      <td className={style.rightCol}>
        <div className={amountClassName}>
          {addition ? '+' : ''}
          <Amount value={amount} currencyCode="rur" />
        </div>
        {swapSubRows ? (
          <div className={style.date}>{date}</div>
        ) : (
          <div className={style.description}>{description}</div>
        )}
      </td>
      {lastCol && <td className={style.lastCol}>{lastCol}</td>}
    </tr>
  )
}

export default FinanceRow
